<template>
  <module title="修改地址">
    <el-form 
      class="com-form"
      ref="form" 
      :model="addressForm"
      label-width="80px"
      label-position="left"
    >
      <el-form-item label="收货人">
        <el-input 
          v-model="addressForm.name"
          placeholder="请填写收货人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input 
          v-model="addressForm.phone"
          placeholder="请填写联系方式"
        ></el-input>
      </el-form-item>
      <el-form-item label="所在地区">
        <div class="flex area-form-item">
          <el-select 
            class="flex-1"
            v-model="addressForm.province_id"
            filterable
            @focus="handleFocusProvince"
            @change="handleChangeProvince"
            placeholder="请选择所在省份"
          >
            <el-option 
              v-for="province in provinces"
              :key="province.id"
              :label="province.name"
              :value="province.id"
            />
          </el-select>

          <el-select 
            class="flex-1"
            v-model="addressForm.city_id"
            filterable
            @focus="handleFocusCity"
            @change="handleChangeCity"
            placeholder="请选择所在市"
          >
            <el-option 
              v-for="city in citys"
              :key="city.id"
              :label="city.name"
              :value="city.id"
            />
          </el-select>
          
          <el-select 
            class="flex-1"
            v-model="addressForm.area_id"
            filterable
            @focus="handleFocusArea"
            placeholder="请选择所在地区"
          >
            <el-option 
              v-for="area in areas"
              :key="area.id"
              :label="area.name"
              :value="area.id"
            />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input 
          v-model="addressForm.detail"
          placeholder="请填写详细地址"
        ></el-input>
      </el-form-item>
      <el-form-item size="large">
        <div @click="saveEditAddress()">
          <com-button class="save-btn" label="保存"></com-button>
        </div>
      </el-form-item>
    </el-form>
  </module>
</template>

<script>
import Module from '@/components/pc/Module';
import $addressMixins from '@/mixins/address';

export default {
  components: {
    Module
  },
  emit: ['changeAddressvisible'],
  props: ['address'],
  created(){
    if(this.address){
      this.addressForm = this.address;
      // 获取省份
      this.handleFocusProvince()
        .then(() =>{
          this.handleFocusCity()
            .then(()=>{
              this.handleFocusArea()
            })
        });
    }
  },
  mixins: [$addressMixins],
}
</script>

<style lang="less" scoped>
.area-form-item .flex-1{
  margin-right: .1rem;
  &:last-of-type{
    margin-right: 0;
  }
}
</style>